// extracted by mini-css-extract-plugin
module.exports = {"emptyContainer":"Empty_emptyContainer__FxLor","emptyImage":"Empty_emptyImage__W5Ww2","emptyDescription":"Empty_emptyDescription__Wtj54","emptyButton":"Empty_emptyButton__qhpT7"};